import Contacts from "./contacts";
import AddContact from "./add-contact";
import EditContact from "./edit-contact";
import ViewContact from "./view-contact";

export default {Contacts, AddContact, EditContact, ViewContact};